/**
 * Toggle Text on click
 * @module toggleText
 */

import $ from 'jquery';
import mergeOptions from 'styleguide/lib/merge-options';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'productFilterCount';

export const DEFAULTS = {};

const countChecked = ($checkboxes) => $checkboxes.filter(':checked').length;

const renderCount = ($checkboxes, $count) => {
  const count = countChecked($checkboxes);
  $count.text(`(${count})`);

  if (count === 0) $count.text('');
};

const onChangeListener = ($checkboxes, $count) => $checkboxes.on('change', () => renderCount($checkboxes, $count));

/**
 * Initializes productFilterCount.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
export default function productFilterCount(container, options = {}) {

  const $container = $(container);
  const opts = mergeOptions(DEFAULTS, options, $container);
  const $count = $(opts.filterCount);
  const $checkboxes = $container.find('input[type="checkbox"]');

  if ($count.length === 0) console.warn('There is no $count selector.');

  renderCount($checkboxes, $count);
  onChangeListener($checkboxes, $count);
}

registerJQueryPlugin(PLUGIN_NAME, productFilterCount);


// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/product-filter-count.js